/*
  Scroll-reveal — adds `is-visible` to any element with
  [data-reveal-on-scroll] the first time it crosses ~15% into the viewport.
  Pairs with assets/scroll-reveal.css for the actual fade/lift.

  Single shared IntersectionObserver across all elements; targets are
  unobserved after firing so it stays cheap on long pages. shopify:section:load
  rewires anything dropped into the page by the theme editor.

  Plain JS, no dependencies (CLAUDE.md §3).
*/
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) {
    // Bail out gracefully — show everything, skip the animation.
    document.addEventListener('DOMContentLoaded', function () {
      var els = document.querySelectorAll('[data-reveal-on-scroll]');
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    },
    {
      threshold: 0.15,
      // Trip slightly *after* the element starts entering — feels less
      // twitchy on fast scroll, prevents firing on a barely-visible sliver.
      rootMargin: '0px 0px -10% 0px'
    }
  );

  function attach(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('[data-reveal-on-scroll]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.dataset.scrollRevealWired === '1') continue;
      el.dataset.scrollRevealWired = '1';
      // Already past the threshold on first paint? Mark visible immediately —
      // skips an animation that would never play and avoids a flash of
      // hidden content above the fold.
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85 && rect.bottom > 0) {
        el.classList.add('is-visible');
        continue;
      }
      observer.observe(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { attach(); });
  } else {
    attach();
  }

  document.addEventListener('shopify:section:load', function (e) {
    attach(e.target);
  });
})();
